import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import JsSIP from 'jssip';
import { nanoid } from 'nanoid';
import ExtensionResource from 'flow/api/extensions';
import ProvisioningResource from 'flow/api/provisioning';
import throttle from 'lodash/throttle';
import appConfig from 'app-config';
import Actions from 'flow/actions';
import { hsIncomingCall, hsOutgoingCall, hsEndCall, hsConfirmCall, hsHoldCall, hsUnholdCall, hsMute, hsUnmute, hsMultipleCalls, hsEndLastCall, logAudioDeviceDataIfAppropriate } from 'flow/actions/headset-actions';
import { decryptSipInfo } from 'flow/utils/transcode-utils';
import { rtcSessionRepresentsCentionErrand, getCentionDataFromRtcSession } from 'flow/utils/omnichannel-utils';
import { rtcSessionRepresentsTicketNonVoice, getTicketDataFromRtcSessionRequest } from 'flow/utils/ticket-utils';
import { OMNICHANNEL_PROPERTIES, routeUserToOmnichannelErrand, onNewOmnichannelSession } from 'flow/actions/omnichannel-actions';
import metricsClient from 'flow/api-clients/metrics-client';
import { setActiveMeetingCallIdAction } from 'flow/actions/meeting-actions';
// Circular with companion-actions (it imports answerCall/startLocalCall from here). Safe because
// neither binding is touched at module evaluation - both are used inside thunk bodies at call time.
import { answerCompanionCall, callOnCompanion, declineCompanionCall, muteCompanion, publishCompanionMuteState, sendCompanionDtmf } from 'flow/companion/companion-actions';
import { canRelayCallToCompanion, isCompanionSignallingSurface, selectCompanionAnswersCalls, shouldRelayToCompanion } from 'flow/companion/companion-utils';
import { selectDesignatedCompanionDevice } from 'flow/selectors/app-selectors';
import { addPhoneLogEntry, getPlayRingtoneSetting, getSoftphoneShouldBeRegistered, savePlayRingtoneSetting, saveSoftphoneShouldBeRegistered, addDeviceLogEntry, addUserPhoneLogEntry, errorMessageIsRTCPeerConnectionGone, addGeneralLogEntry, getVideoConferenceWithSip, addSipConnectionEstablishedDiv, getBlindTransferSetting, addOmniChannelLogEntry, addTicketLogEntry } from 'flow/utils/browser-utils';
import { getCountryCode } from 'flow/utils/extension-utils';
import { getCurrentDateMinusOneDayForSimlog } from 'flow/utils/date-time-utils';
import { calculateBackoffTime, MAX_BACKOFF_MS, parseSipSockets } from 'flow/utils/socket-utils';
import { networkErrorDispatcher, setMicPermission, setSnackbar } from 'flow/actions/app-actions';
import { AttendedTransferState, CallMethodType, callShouldBeAnsweredAutomatically, CallTransferType, getUserAgentName, PlayRingtoneSetting, removeExtraCharacters, senderSupportsDtmf, NewCallBlockReason, blocksOnlyOrigination, sessionHasAudioTracks, filterOutTCPCandidates, filterOutCryptoLineInSDP, BLIND_TRANSFER_SETTINGS, filterOutPaiHeader } from 'flow/utils/call-utils';
import { getLocalCallIds, getLocalCallSessions, getPhoneIsMuted, getFocusedLocalCallId, getLocalSessionFromCallId, hasActiveCallsBlockingNewCall, getFocusedSession, getFocusedActiveCall, getOwnActiveCallByCallId, getNumLocalCalls, getPaiHeaderFromLocalCall, getPendingTransferCallKey, getPendingTransferNumber, TREAT_CENTION_ERRANDS_LIKE_PHONE_CALLS_EXPERIMENTAL_FEATURE, SHOULD_DELAY_REMOVAL_OF_SESSION_OF_TYPE_CENTION_ERRAND, selectSoftphoneIsRegistered } from 'flow/selectors/call-selectors';
import { ToneGenerator } from 'resources/tone-generator';
import { getAutoAnswerWithIpPhone, getCallWaitingEnabled, getOwnExtensionKey, getOwnSipUserInfo } from 'flow/selectors/selectors';
import { toggleCall, setPinCode } from 'flow/actions/extension-actions';
import { ensureFreshGeoLocation, fetchGeoRestrictionEnabled, reportOutsideRegionToSurfaces, resolveGeoLocation, setGeoOutsideFence } from 'flow/actions/geolocation-actions';
import { selectCallingNeedsCompanion } from 'flow/selectors/companion-selectors';
import { selectPositionIsUnavailable, selectGeoLocationCoordinates, selectGeoLocationIsReported } from 'flow/selectors/geolocation-selectors';
import { GEO_FIX_WAIT_MS, geoLocationExtraHeader, geoRestrictionIsDeployed, onGeoLocationPermissionGranted } from 'flow/utils/geolocation-utils';
import { permissionToMicrophoneIsGranted, getMicrophonePermissionState, getConnectedMediaDeviceOfKindWithId, getMediaConstraints, setOutputDeviceWithIdToElement, permissionTypes } from 'flow/utils/media-utils';
import { applyNoiseSuppression, releaseNoiseSuppression } from 'flow/actions/noise-suppression-actions';
import { putMeetingOnHold } from 'flow/actions/meeting-actions';
import { history } from 'flow/configure-store';
import { generatePath } from 'flow/utils/router-utils';
import { routes } from 'flow/types/routes';
import { spawnNotificationNewTicket } from 'flow/actions/tickets-action';
import { selectMeetingIsActive, selectMeetingIsInFocus } from 'flow/selectors/meeting-selectors';
import { segmentTrack } from 'flow/actions/segment-actions';
import { EVENT_STRINGS } from 'flow/utils/segment-utils';
import { RingTonePlayer } from 'resources/ringtone-player';
import { getFaro } from 'flow/api-clients/faro-client';
import { homeActionUrlPath } from 'flow/utils';
import { selectNotification } from 'flow/selectors/app-selectors';
import { IS_UAE_HOST, IS_UK_HOST } from 'flow/utils/browser-utils-TW';
import { FALLBACK_SIP_PROXIES, FALLBACK_SIP_PROXIES_UAE, FALLBACK_SIP_PROXIES_UK } from 'flow/constants/sip-proxy-constants';
var BUSY_TERMINATE_OPTIONS = {
  status_code: '486',
  reason_phrase: 'Busy Here'
};
export var COMPANION_ANSWER_FALLBACK_MS = 3000;
var isRingingIncomingCall = function isRingingIncomingCall(session) {
  return session.direction === 'incoming' && session.isInProgress() && !session.isEstablished() && !rtcSessionRepresentsTicketNonVoice(session) && !rtcSessionRepresentsCentionErrand(session);
};
var UPDATE_PROXIES_THROTTLE_MS = 2 * 60 * 1000;
var SIP_CLUSTER = IS_UAE_HOST ? 'sip.tvx.etisalat.ae' : IS_UK_HOST ? 'sip.telavox.co.uk' : 'sip.telavox.se';
export var SIP_PROXIES = IS_UAE_HOST ? FALLBACK_SIP_PROXIES_UAE : IS_UK_HOST ? FALLBACK_SIP_PROXIES_UK : FALLBACK_SIP_PROXIES;
export var SIP_PROXIES_FROM_PROVISIONING = false;
var isStarted = false;
var registerUserAgentOnCallEnded = false;
var sipOptionsIntervalId = null;
var catchJssipDebugLogs = function catchJssipDebugLogs() {
  var printInConsole = !appConfig.production;
  if (!JsSIP._default_debug) {
    JsSIP._default_debug = JsSIP.debug.log;
  }
  JsSIP.debug.log = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (printInConsole) {
      JsSIP._default_debug.apply(JsSIP, args);
    }
    var logString = args[0].replace(/%c/g, ''); // Remove coloring syntax used by debug tool.
    addPhoneLogEntry(logString);
  };
};
var calculateStatsOverTime = function calculateStatsOverTime(stats, firstStatEntry) {
  var totalOutgoingAudioLevel = 0;
  var totalRoundTripTime = 0;
  var totalIncomingAudioLevel = 0;
  var totalRemoteRoundTripTime = 0;
  var lastStatEntry = stats.length - 1;
  var numberOfStatEntries = lastStatEntry - firstStatEntry + 1;
  for (var i = firstStatEntry; i <= lastStatEntry; i++) {
    totalOutgoingAudioLevel += stats[i].outgoingAudioLevel;
    totalRoundTripTime += stats[i].currentRoundTripTime;
    totalIncomingAudioLevel = stats[i].incomingAudioLevel;
    totalRemoteRoundTripTime = stats[i].remoteRoundTripTime;
  }
  var firstStat = stats[firstStatEntry];
  var lastStat = stats[lastStatEntry];
  var jitterBufferDelay = lastStat.jitterBufferDelay - firstStat.jitterBufferDelay;
  var jitterBufferEmittedCount = lastStat.jitterBufferEmittedCount - firstStat.jitterBufferEmittedCount;
  var secondsBetweenEntries = (lastStat.timestamp - firstStat.timestamp) / 1000;
  var jitterPerSecond = (lastStat.jitter - firstStat.jitter) / secondsBetweenEntries;
  var remoteJitterPerSecond = (lastStat.remoteJitter - firstStat.remoteJitter) / secondsBetweenEntries;
  var candidatePairs = {};
  for (var _i = 0, _Object$entries = Object.entries(lastStat.candidatePairs); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      id = _Object$entries$_i[0],
      pair = _Object$entries$_i[1];
    var prevPair = 'candidatePairs' in firstStat ? firstStat.candidatePairs[id] : null;
    var pairStats = {
      requestsSent: pair.requestsSent - (prevPair ? prevPair.requestsSent : 0),
      consentRequestsSent: pair.consentRequestsSent - (prevPair ? prevPair.consentRequestsSent : 0),
      responsesReceived: pair.responsesReceived - (prevPair ? prevPair.responsesReceived : 0),
      currentRoundTripTime: pair.currentRoundTripTime,
      state: pair.state,
      remote: "".concat(pair.remoteIp, ":").concat(pair.remotePort),
      local: "".concat(pair.localIp, ":").concat(pair.localPort)
    };
    candidatePairs[id] = pairStats;
  }
  return {
    averageOutgoingAudioLevel: totalOutgoingAudioLevel / numberOfStatEntries,
    averageIncomingAudioLevel: totalIncomingAudioLevel / numberOfStatEntries,
    averageRoundTripTime: totalRoundTripTime / numberOfStatEntries,
    packetsReceived: lastStat.packetsReceived - firstStat.packetsReceived,
    packetsLost: lastStat.packetsLost - firstStat.packetsLost,
    jitterPerSecond: jitterPerSecond,
    averageJitterBufferDelay: jitterBufferDelay / jitterBufferEmittedCount,
    packetsSent: lastStat.packetsSent - firstStat.packetsSent,
    retransmittedPacketsSent: lastStat.retransmittedPacketsSent - firstStat.retransmittedPacketsSent,
    remoteAverageRoundTripTime: totalRemoteRoundTripTime / numberOfStatEntries,
    remotePacketsLost: lastStat.remotePacketsLost - firstStat.remotePacketsLost,
    remoteJitterPerSecond: remoteJitterPerSecond,
    candidatePairs: candidatePairs
  };
};
export var updateSipProxies = function updateSipProxies() {
  return new Promise(function (resolve) {
    ProvisioningResource.getSipServers({
      onResult: function onResult(json) {
        var _ref, _SIP_PROXIES$size, _SIP_PROXIES, _SIP_PROXIES2;
        // Update our list with the successful response
        SIP_PROXIES = parseSipSockets(json);
        SIP_PROXIES_FROM_PROVISIONING = ((_ref = (_SIP_PROXIES$size = (_SIP_PROXIES = SIP_PROXIES) === null || _SIP_PROXIES === void 0 ? void 0 : _SIP_PROXIES.size) !== null && _SIP_PROXIES$size !== void 0 ? _SIP_PROXIES$size : (_SIP_PROXIES2 = SIP_PROXIES) === null || _SIP_PROXIES2 === void 0 ? void 0 : _SIP_PROXIES2.length) !== null && _ref !== void 0 ? _ref : 0) > 0;
        resolve();
      },
      // If the request gets an error, we want to keep running
      // The SIP_PROXIES variable will have it's old values
      onError: resolve,
      onClientError: resolve
    });
  });
};
export var updateSipProxiesAsGuest = function updateSipProxiesAsGuest() {
  return new Promise(function (resolve) {
    ProvisioningResource.getSipServersAsGuest({
      onResult: function onResult(json) {
        SIP_PROXIES = parseSipSockets(json);
        resolve();
      },
      // If the request gets an error, we want to keep running
      // The SIP_PROXIES variable will have it's old values
      onError: resolve,
      onClientError: resolve
    });
  });
};
var updateSipProxiesThrottled = throttle(updateSipProxies, UPDATE_PROXIES_THROTTLE_MS, {
  trailing: false
});
export var configureJsSIPLogs = function configureJsSIPLogs() {
  JsSIP.debug.enable('JsSIP:*');
  catchJssipDebugLogs();
};
var sendCallEndedMetric = function sendCallEndedMetric(data, session) {
  var cause = Object.keys(JsSIP.C.causes).find(function (key) {
    return JsSIP.C.causes[key] === data.cause;
  });
  var path = [session.direction, data.originator, cause];
  metricsClient.sendCallEndedMetric(path);
};
var onSessionEndedOrFailed = function onSessionEndedOrFailed(data, session) {
  return function (dispatch, getState) {
    var _session$data;
    var state = getState();
    var phone = state.phone;
    clearInterval(session.data.webrtcStatsTimer);
    clearInterval(session.data.rtpPollingIntervalForDeterminingProgressTones);
    releaseNoiseSuppression(session);
    sendCallEndedMetric(data, session);
    dispatch(hsEndCall(session.data['callId'], session.data.hungupThroughHeadset));
    var numLocalCalls = getNumLocalCalls(getState());
    var paiHeader = getPaiHeaderFromLocalCall(state);
    if (numLocalCalls === 1) {
      //Not unmuting if session ended is non-call item
      if (!rtcSessionRepresentsTicketNonVoice(session)) {
        // If the last session is about to end, reset the mute state
        dispatch({
          type: Actions.PHONE_MUTED,
          muted: false
        });
      }
      dispatch(hsEndLastCall());
      ToneGenerator.context.suspend();
    }
    if (registerUserAgentOnCallEnded && numLocalCalls === 1) {
      registerUserAgentOnCallEnded = false;
      var userAgent = phone.get('userAgent');
      userAgent.register();
    }
    if (paiHeader) {
      // Setting a timeout because the call item is still present for about 3-4s after the call has eneded.
      setTimeout(function () {
        dispatch(removePaiHeader());
      }, 5000);
    }
    var sessionBrowserNotification = selectNotification(getState(), session === null || session === void 0 || (_session$data = session.data) === null || _session$data === void 0 ? void 0 : _session$data['callId']);
    sessionBrowserNotification === null || sessionBrowserNotification === void 0 || sessionBrowserNotification.close();
    if (rtcSessionRepresentsCentionErrand(session) && SHOULD_DELAY_REMOVAL_OF_SESSION_OF_TYPE_CENTION_ERRAND(getState()) && data && data.cause === 'Terminated') {
      // This here to avoid having calls/errands 'ring' out to the user directly after an ongoing session for an
      // omnichannel errand has been terminated.
      // The reason for this is that we want to be as sure as we can be that the wrapup profile, if one exists, has
      // been activated.
      setTimeout(function () {
        dispatch({
          type: Actions.PHONE_REMOVE_SESSION,
          callId: session.data['callId']
        });
      }, 1000);
    } else {
      dispatch({
        type: Actions.PHONE_REMOVE_SESSION,
        callId: session.data['callId']
      });
    }
    dispatch(putMeetingOnHold(false));
  };
};
var BAD_LOCATION_INFORMATION = 424;
var OUTSIDE_THE_FENCE_REASON = 'outside the fence';
var isOutsideTheFence = function isOutsideTheFence(reasonPhrase) {
  return "".concat(reasonPhrase !== null && reasonPhrase !== void 0 ? reasonPhrase : '').toLowerCase().includes(OUTSIDE_THE_FENCE_REASON);
};
export var handleSIPFailed = function handleSIPFailed(data, session) {
  return function (dispatch) {
    var _data$message;
    sendCallEndedMetric(data, session);
    addPhoneLogEntry("Session failed with cause: \"".concat(data.cause, "\" -> attempting to stop locally generated tones"));
    stopTones();
    if (JsSIP.C.causes.BUSY === data.cause) {
      addPhoneLogEntry('Session failed. Reason: busy. Attempting to play locally generated busy tone');
      playBusyTone();
    }
    if (JsSIP.C.causes.USER_DENIED_MEDIA_ACCESS === data.cause) {
      addPhoneLogEntry('Session failed. Reason: User denied media access - mic permission turned off?');
      dispatch(setMicPermission(false));
    }
    if (JsSIP.C.causes.UNAVAILABLE === data.cause) {
      addPhoneLogEntry('Session failed. Reason: Callee is unavailable. Attempting to play locally generated disconnect tone');
      playDisconnectTone();
    }
    if (JsSIP.C.causes.NOT_FOUND === data.cause) {
      addPhoneLogEntry('Session failed. Reason: Callee returned not found. Attempting to play locally generated disconnect tone');
      playDisconnectTone();
    }
    if (((_data$message = data.message) === null || _data$message === void 0 ? void 0 : _data$message.status_code) === BAD_LOCATION_INFORMATION) {
      addPhoneLogEntry("Session failed. Reason: the proxy refused the location: ".concat(data.message.reason_phrase));
      var outsideTheFence = isOutsideTheFence(data.message.reason_phrase);
      dispatch(setSnackbar({
        i18nextMessage: outsideTheFence ? 'calling.outside_permitted_region' : 'calling.location_not_confirmed',
        hasCloseButton: true
      }));
      if (outsideTheFence) {
        dispatch(setGeoOutsideFence(true));
        dispatch(reportOutsideRegionToSurfaces());
      }
    }
    dispatch(onSessionEndedOrFailed(data, session));
  };
};
var addConnectionEventListeners = function addConnectionEventListeners(session, dispatch) {
  var connection = session.connection;
  addUserPhoneLogEntry('ICE signaling state: ', connection.signalingState);
  connection.onsignalingstatechange = function () {
    addUserPhoneLogEntry('ICE signaling state: ', connection.signalingState);
  };
  addUserPhoneLogEntry('RTCPeerConnection state: ', connection.connectionState);
  connection.onconnectionstatechange = function () {
    addUserPhoneLogEntry('RTCPeerConnection state: ', connection.connectionState);
  };
  addUserPhoneLogEntry('ICE connection state: ', connection.iceConnectionState);
  connection.oniceconnectionstatechange = function () {
    addUserPhoneLogEntry('ICE connection state: ', connection.iceConnectionState);
    if (connection.iceConnectionState === 'checking') {
      try {
        var iceTransport = session.connection.getSenders()[0].transport.iceTransport;
        iceTransport.onselectedcandidatepairchange = function () {
          var pair = iceTransport.getSelectedCandidatePair();
          addUserPhoneLogEntry("ICE candidate pair selected, local: ".concat(pair.local.address, ":").concat(pair.local.port, " remote: ").concat(pair.remote.address, ":").concat(pair.remote.port));
        };
      } catch (_e) {
        addUserPhoneLogEntry("Failed to get ice transport, that's weird!");
      }
    }
  };
  addUserPhoneLogEntry('ICE gathering state: ', connection.iceGatheringState);
  connection.onicegatheringstatechange = function () {
    addUserPhoneLogEntry('ICE gathering state: ', connection.iceGatheringState);
  };
  if (connection.addTrack) {
    connection.ontrack = function (event) {
      return dispatch(handleReceiveStream(event.streams[0], session));
    };
  } else {
    connection.onaddstream = function (event) {
      return dispatch(handleReceiveStream(event.stream, session));
    };
  }
};
export var stopUserAgent = function stopUserAgent() {
  return function (_dispatch, getState) {
    var _getState = getState(),
      phone = _getState.phone;
    var userAgent = phone.get('userAgent');
    stopWatchingGeoLocationPermission();
    if (userAgent) {
      isStarted = false;
      userAgent.stop();
    }
  };
};
export var createInitialUserAgent = function createInitialUserAgent() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return updateSipProxies();
          case 1:
            if (!geoRestrictionIsDeployed()) {
              _context.next = 2;
              break;
            }
            _context.next = 2;
            return dispatch(fetchGeoRestrictionEnabled());
          case 2:
            if (!selectGeoLocationIsReported(getState())) {
              _context.next = 4;
              break;
            }
            _context.next = 3;
            return dispatch(resolveGeoLocationForSoftphone());
          case 3:
            dispatch(watchGeoLocationPermission());
          case 4:
            dispatch(createUserAgent());
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var registerSoftphoneWithGeoLocation = function registerSoftphoneWithGeoLocation() {
  return function (_dispatch, getState) {
    var state = getState();
    var userAgent = state.phone.get('userAgent');
    var loggedInWithTempPass = !!state.app.get('temporaryPasswordState');
    if (!userAgent || !selectGeoLocationCoordinates(state) || selectPositionIsUnavailable(state) || selectSoftphoneIsRegistered(state) || !getSoftphoneShouldBeRegistered(loggedInWithTempPass)) {
      return;
    }
    addPhoneLogEntry('Geo location: position available, registering the softphone');
    setGeoLocationRegisterHeader(userAgent, state);
    userAgent.register();
  };
};
var resolveGeoLocationForSoftphone = function resolveGeoLocationForSoftphone(timeoutMs) {
  return function (dispatch) {
    return dispatch(resolveGeoLocation(timeoutMs, function () {
      return dispatch(registerSoftphoneWithGeoLocation());
    }));
  };
};
export var retryGeoLocation = function retryGeoLocation() {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (selectGeoLocationIsReported(getState())) {
              _context2.next = 1;
              break;
            }
            return _context2.abrupt("return");
          case 1:
            addPhoneLogEntry('Geo location: retrying for a position');
            _context2.next = 2;
            return dispatch(resolveGeoLocationForSoftphone());
          case 2:
            dispatch(registerSoftphoneWithGeoLocation());
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var stopGeoLocationPermissionWatch = null;
var stopWatchingGeoLocationPermission = function stopWatchingGeoLocationPermission() {
  var _stopGeoLocationPermi;
  (_stopGeoLocationPermi = stopGeoLocationPermissionWatch) === null || _stopGeoLocationPermi === void 0 || _stopGeoLocationPermi();
  stopGeoLocationPermissionWatch = null;
};
var watchGeoLocationPermission = function watchGeoLocationPermission() {
  return function (dispatch) {
    if (stopGeoLocationPermissionWatch) {
      return;
    }
    stopGeoLocationPermissionWatch = onGeoLocationPermissionGranted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            addPhoneLogEntry('Geo location permission granted');
            _context3.next = 1;
            return dispatch(resolveGeoLocationForSoftphone());
          case 1:
            dispatch(registerSoftphoneWithGeoLocation());
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
  };
};
var setGeoLocationRegisterHeader = function setGeoLocationRegisterHeader(userAgent, state) {
  if (!selectGeoLocationIsReported(state)) {
    return;
  }
  var coordinates = selectGeoLocationCoordinates(state);
  userAgent.registrator().setExtraHeaders(coordinates ? [geoLocationExtraHeader(coordinates)] : []);
};
export var createUserAgent = function createUserAgent() {
  var prevAttempts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch, getState) {
      var existingUserAgent, nextAttempt, proxySockets, sipInfo, username, password, embedded, userAgentName, loggedInWithTempPass, needsCompanion, geoBlocked, configuration, userAgent;
      return _regeneratorRuntime.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            // Stop any existing UserAgent before creating a new one, so a second
            // boot can't leave two registrations live for the same user. Skip while
            // in a call: UA.stop() also terminates active RTCSessions (would drop
            // the call), matching how registrationExpiring/registrationFailed defer
            // teardown. stop() on an already-stopped UA (reconnect path) is a no-op.
            existingUserAgent = getState().phone.get('userAgent');
            if (existingUserAgent && getNumLocalCalls(getState()) === 0) {
              addPhoneLogEntry('createUserAgent called while a UserAgent already exists. Stopping the existing one to avoid duplicate SIP registrations.');
              isStarted = false;
              existingUserAgent.stop();
            }
            // Clear the old UA's SIP OPTIONS keep-alive before the new UA overwrites
            // the (module-global) interval id below.
            clearInterval(sipOptionsIntervalId);
            nextAttempt = prevAttempts + 1;
            proxySockets = SIP_PROXIES.map(function (proxy) {
              return {
                socket: new JsSIP.WebSocketInterface(proxy.socketUrl),
                weight: proxy.weight
              };
            });
            sipInfo = getOwnSipUserInfo(getState());
            username = decryptSipInfo(sipInfo.get('username'));
            password = decryptSipInfo(sipInfo.get('password'));
            embedded = getState().app.get('embedded');
            userAgentName = getUserAgentName(embedded);
            loggedInWithTempPass = !!getState().app.get('temporaryPasswordState');
            needsCompanion = selectCallingNeedsCompanion(getState());
            geoBlocked = selectPositionIsUnavailable(getState()) || needsCompanion;
            if (geoBlocked) {
              addPhoneLogEntry(needsCompanion ? 'A companion is required in this region and none is usable -- not registering the softphone' : 'Location sharing is off and a position is required in this region -- not registering the softphone');
            }
            configuration = {
              sockets: _toConsumableArray(proxySockets),
              uri: "sip:".concat(username, "@").concat(sipInfo.get('server') || SIP_CLUSTER),
              password: password,
              session_timers: false,
              no_answer_timeout: 150,
              register: getSoftphoneShouldBeRegistered(loggedInWithTempPass) && !geoBlocked,
              user_agent: userAgentName,
              connection_recovery_max_interval: MAX_BACKOFF_MS / 1000
            };
            userAgent = new JsSIP.UA(configuration);
            setGeoLocationRegisterHeader(userAgent, getState());
            userAgent.on('newRTCSession', function (callData) {
              var state = getState();
              var phone = state.phone;
              var session = callData.session;
              var callId = callData.request.getHeader('Call-ID');
              var simlogFromDate = getCurrentDateMinusOneDayForSimlog();
              addPhoneLogEntry("New RTC session\n\nhttp://simlog1.service.telavox.se:8099/?from=".concat(simlogFromDate, "&callid=").concat(callId));
              var isVideoMeetingCall = callData.request.getHeader('X-TVX-IS-VIDEO-MEETING-CALL');
              if (isVideoMeetingCall) {
                session.data.callId = callId;
                session.data.isMeeting = true;
                dispatch(setActiveMeetingCallIdAction(callId));
                // It's a meeting, it has it's own event handlers
                return;
              }
              if (rtcSessionRepresentsCentionErrand(session)) {
                var deepLinkId = getCentionDataFromRtcSession(session, OMNICHANNEL_PROPERTIES.DEEP_LINK.value);
                addOmniChannelLogEntry('Incoming omnichannel errand with deepLinkId: ', deepLinkId);
                if (!TREAT_CENTION_ERRANDS_LIKE_PHONE_CALLS_EXPERIMENTAL_FEATURE(getState())) {
                  // The standard behaviour, as it was implemented, is that we display a notification for
                  // omni errands (executed below, in onNewOmnichannelSession), and do not set any
                  // session to the state (see return statement below).
                  // This has the implication that there are cases where we display a notification for
                  // an incoming errand (an email, or some other supported channel that is not a phone call)
                  // at the same time as we display the call canvas for a phone call.
                  // Maybe this isn't how it should work(?) but as this is how it was implemented, we start out with
                  // testing handling omni errands just like phone calls for one specific customer only
                  // (...i.e. for that customer continuing with the code outside this if block.
                  // Most importantly: setting the session to the state, which causes us to terminate other incoming
                  // sessions while the omni errand is 'ringing' out to the user)
                  dispatch(onNewOmnichannelSession(session));
                  return;
                }
              }
              if (!callData.request.getHeader('X-TVX-LID')) {
                var xTvxLid = nanoid();
                callData.request.setHeader('X-TVX-LID', xTvxLid);
              }
              session.data['callId'] = callId;
              var lid = callData.request.getHeader('X-TVX-LID');
              session.data['logId'] = lid;
              var agentInfo = callData.request.getHeader('X-TVX-AGENT-INFO');
              var isUnParking = phone.get('unparking');
              var takeMeetingIntoAccount = selectMeetingIsActive(state) && getVideoConferenceWithSip();
              var numberOfCalls = takeMeetingIntoAccount ? getNumLocalCalls(getState()) + 1 : getNumLocalCalls(getState());
              var isMultipleCall = numberOfCalls > 0;
              var isQueueCall = callData.request.getHeader('X-Tvx-Queuename');
              session.data['isQueueCall'] = !!isQueueCall;
              if (isMultipleCall && session.direction === 'incoming') {
                var newCallBlockReason = hasActiveCallsBlockingNewCall(state, 'incoming', 2);
                if (newCallBlockReason === NewCallBlockReason.NONE || blocksOnlyOrigination(newCallBlockReason)) {
                  dispatch(segmentTrack(EVENT_STRINGS.USER_GOT_ANOTHER_CALL, {
                    callId: callId,
                    callWaitingEnabled: getCallWaitingEnabled(state),
                    reasonToBlockCall: newCallBlockReason
                  }));
                } else {
                  addUserPhoneLogEntry('New RTC session -> terminating session with callId: ' + callId + ' reason: ', newCallBlockReason.key);
                  session.terminate(BUSY_TERMINATE_OPTIONS);
                  return;
                }
              }
              session.data.webrtcStats = [];
              session.data.lastDumpedStatEntry = 0;
              if (isMultipleCall) {
                dispatch(hsMultipleCalls());
              }
              var isTelavoxTicketNonCall = rtcSessionRepresentsTicketNonVoice(session);
              var telavoxTicketData = isTelavoxTicketNonCall ? getTicketDataFromRtcSessionRequest(session) : undefined;
              var telavoxTicketId = telavoxTicketData ? telavoxTicketData.ticketId : undefined;
              if (isTelavoxTicketNonCall) {
                addTicketLogEntry("Incoming SIP session for ticket: ".concat(telavoxTicketId));
                dispatch(spawnNotificationNewTicket("ticket-".concat(telavoxTicketId), telavoxTicketData === null || telavoxTicketData === void 0 ? void 0 : telavoxTicketData.message, telavoxTicketData === null || telavoxTicketData === void 0 ? void 0 : telavoxTicketData.channel, callId));
              }
              dispatch(_objectSpread(_objectSpread({
                type: Actions.PHONE_NEW_SESSION,
                sessionObject: session,
                callId: callId
              }, agentInfo && {
                agentInfo: JSON.parse(atob(agentInfo))
              }), {}, {
                isTelavoxTicketNonCall: isTelavoxTicketNonCall,
                telavoxTicketData: telavoxTicketData,
                telavoxTicketId: telavoxTicketId
              }));
              if (session.direction === 'incoming') {
                dispatch(hsIncomingCall(session.data['callId']));
              } else {
                dispatch(hsOutgoingCall(session.data['callId']));
              }
              if (isUnParking) {
                addPhoneLogEntry('Unparking, attempting to "answer" call');
                dispatch(_answerCall(session));
                //Needed for the gui not to jump, and show the answer call button
                setTimeout(function () {
                  return dispatch({
                    type: Actions.FINISH_UNPARKING
                  });
                }, 400);
              } else if (callShouldBeAnsweredAutomatically(callData)) {
                addPhoneLogEntry('Answering call automatically');
                dispatch(_answerCall(session));
              }
              session.on('reinvite', function (data) {
                var paiHeader = data.request.getHeader('P-Asserted-Identity');
                if (paiHeader) {
                  var match = filterOutPaiHeader(paiHeader);
                  if (match) {
                    session.data.pai = match;
                    dispatch(setPaiHeader(session.data.pai));
                    addPhoneLogEntry("Found PAI-header in reinvite: ".concat(match));
                  }
                }
              });
              session.on('accepted', function () {
                if (isMultipleCall && session.direction === 'incoming') {
                  dispatch(segmentTrack(EVENT_STRINGS.USER_ACCEPTED_SECOND_CALL, {
                    callId: callId
                  }));
                }
                addPhoneLogEntry('Session accepted -> Attempting to stop locally generated tones');
                clearInterval(session.data.rtpPollingIntervalForDeterminingProgressTones);
                stopTones();
                dispatch({
                  type: Actions.PHONE_SESSION_ACCEPTED,
                  callId: session.data['callId']
                });
              });
              session.on('progress', function (data) {
                addPhoneLogEntry('Session progress');
                if (rtcSessionRepresentsTicketNonVoice(session)) {
                  addPhoneLogEntry('Session is ticket non voice, no-op on progress');
                  return;
                }

                // Don't play any ringtones in incoming calls that we auto answer, that
                // could lead to ringtones being played after the call has been answered
                if (session.direction === 'incoming' && !isUnParking && !callShouldBeAnsweredAutomatically(callData)) {
                  addPhoneLogEntry('Session progress -> call is incoming. Attempting to play locally generated ringtone');
                  if (getCallWaitingEnabled(getState()) && getLocalCallIds(getState()).length > 1) {
                    ToneGenerator.playCallWaitingTone();
                  } else {
                    dispatch(playRingTone());
                  }
                } else if (session.direction === 'outgoing') {
                  addPhoneLogEntry('Session progress -> call is outgoing');

                  //https://tools.ietf.org/html/rfc3960
                  if (data.response.status_code === 180) {
                    /**
                     * !inboundAudioRtpReceived is to avoid having progress tones played from more than one source.
                     */
                    var inboundAudioRtpReceived = session.data['inboundAudioRtpReceived'];
                    if (!inboundAudioRtpReceived) {
                      addPhoneLogEntry('Session progress -> call is outgoing -> Attempting to play locally generated progress tone');
                      dispatch(playRingbackTone());
                    }
                  }
                }
              });
              session.on('confirmed', function () {
                dispatch(applyNoiseSuppression(session));
                dispatch(hsConfirmCall(session.data['callId'], session.direction === 'incoming', session.data.answeredThroughHeadset));
                var getInitialStats = function getInitialStats() {
                  return {
                    outgoingAudioLevel: 0,
                    currentRoundTripTime: 0,
                    packetsReceived: 0,
                    packetsLost: 0,
                    jitter: 0,
                    timestamp: 0,
                    incomingAudioLevel: 0,
                    jitterBufferDelay: 0,
                    jitterBufferEmittedCount: 0,
                    packetsSent: 0,
                    retransmittedPacketsSent: 0,
                    remotePacketsLost: 0,
                    remoteJitter: 0,
                    remoteRoundTripTime: 0
                  };
                };
                session.data.webrtcStats.push(getInitialStats());
                var statIteration = 0;
                session.data.webrtcStatsTimer = setInterval(function () {
                  session.connection.getStats().then(function (stats) {
                    var statsToSave = getInitialStats();
                    var candidatePairs = {};
                    var candidates = {};
                    stats.forEach(function (report) {
                      if (report.type === 'media-source') {
                        statsToSave['outgoingAudioLevel'] = report.audioLevel;
                      } else if (report.type === 'inbound-rtp') {
                        statsToSave['packetsReceived'] = report.packetsReceived;
                        statsToSave['packetsLost'] = report.packetsLost;
                        statsToSave['jitter'] = report.jitter;
                        statsToSave['timestamp'] = report.timestamp;
                      } else if (report.type === 'track' && report.remoteSource) {
                        statsToSave['incomingAudioLevel'] = report.audioLevel;
                        statsToSave['jitterBufferDelay'] = report.jitterBufferDelay;
                        statsToSave['jitterBufferEmittedCount'] = report.jitterBufferEmittedCount;
                      } else if (report.type === 'outbound-rtp') {
                        statsToSave['packetsSent'] = report.packetsSent;
                        statsToSave['retransmittedPacketsSent'] = report.retransmittedPacketsSent;
                      } else if (report.type === 'remote-inbound-rtp') {
                        statsToSave['remotePacketsLost'] = report.packetsLost;
                        statsToSave['remoteJitter'] = report.jitter;
                        statsToSave['remoteRoundTripTime'] = report.roundTripTime;
                      } else if (report.type === 'candidate-pair') {
                        candidatePairs[report.id] = report;
                      } else if (report.type === 'remote-candidate' || report.type === 'local-candidate') {
                        candidates[report.id] = report;
                      }
                    });
                    if (Object.keys(candidatePairs).length !== 0) {
                      statsToSave.candidatePairs = Object.values(candidatePairs).reduce(function (prev, _ref6) {
                        var id = _ref6.id,
                          requestsSent = _ref6.requestsSent,
                          consentRequestsSent = _ref6.consentRequestsSent,
                          responsesReceived = _ref6.responsesReceived,
                          currentRoundTripTime = _ref6.currentRoundTripTime,
                          state = _ref6.state,
                          remoteCandidateId = _ref6.remoteCandidateId,
                          localCandidateId = _ref6.localCandidateId;
                        prev[id] = {
                          requestsSent: requestsSent,
                          consentRequestsSent: consentRequestsSent,
                          responsesReceived: responsesReceived,
                          currentRoundTripTime: currentRoundTripTime,
                          state: state,
                          remoteIp: candidates[remoteCandidateId].ip,
                          remotePort: candidates[remoteCandidateId].port,
                          localIp: candidates[localCandidateId].ip,
                          localPort: candidates[localCandidateId].port
                        };
                        return prev;
                      }, {});
                    }
                    session.data.webrtcStats.push(statsToSave);
                    statIteration++;
                    if (statIteration % 10 === 0) {
                      try {
                        var statsToReport = calculateStatsOverTime(session.data.webrtcStats, session.data.lastDumpedStatEntry);
                        session.data.lastDumpedStatEntry = session.data.webrtcStats.length - 1;
                        addUserPhoneLogEntry('Call stats: ', statsToReport);
                      } catch (error) {
                        addUserPhoneLogEntry("Call stats: failed to calculate stats with error: ".concat(error));
                      }
                    }
                  });
                }, 1000);
                if (getPhoneIsMuted(getState())) {
                  session.mute();
                }
              });
              session.on('ended', function (data) {
                try {
                  var statsToReport = calculateStatsOverTime(session.data.webrtcStats, 0);
                  addUserPhoneLogEntry('Final call stats: ', statsToReport);
                } catch (error) {
                  addUserPhoneLogEntry("Final call stats: failed to calculate stats with error: ".concat(error));
                }
                sendCallEndedMetric(data, session);
                addPhoneLogEntry('Session ended -> attempting to stop locally generated tones');
                stopTones();
                if (data.originator !== 'local' && !rtcSessionRepresentsTicketNonVoice(session)) {
                  addPhoneLogEntry('Session ended -> attempting to play locally generated disconnect tone');
                  playDisconnectTone();
                }
                dispatch(onSessionEndedOrFailed(data, session));
              });
              session.on('failed', function (data) {
                dispatch(handleSIPFailed(data, session));
              });
              session.on('muted', function () {
                addPhoneLogEntry("Muted session with callid ".concat(session.data.callId));
                dispatch(hsMute(session.data.callId));
              });
              session.on('unmuted', function () {
                addPhoneLogEntry("Unmuted session with callid ".concat(session.data.callId));
                dispatch(hsUnmute(session.data.callId));
              });
              session.on('sdp', function (data) {
                if (data.originator === 'local') {
                  data.sdp = filterOutTCPCandidates(data.sdp);
                } else if (data.originator === 'remote' && data.type === 'offer') {
                  data.sdp = filterOutCryptoLineInSDP(data.sdp);
                }
                if (session.data.iceTimeoutTimer) {
                  clearTimeout(session.data.iceTimeoutTimer);
                }
              });
              session.on('icecandidate', function (data) {
                if (!session.data.iceTimeoutTimer) {
                  session.data.iceTimeoutTimer = setTimeout(function () {
                    data.ready();
                  }, 500);
                }
              });
              session.on('hold', function (data) {
                if (data.originator !== 'local') {
                  return;
                }
                dispatch({
                  type: Actions.PHONE_ISONHOLD,
                  isOnHold: true,
                  callId: session.data.callId
                });
                dispatch(hsHoldCall(session.data['callId']));
              });
              session.on('unhold', function (data) {
                if (data.originator !== 'local') {
                  return;
                }
                dispatch({
                  type: Actions.PHONE_ISONHOLD,
                  isOnHold: false,
                  callId: session.data.callId
                });
                dispatch(hsUnholdCall(session.data['callId']));
              });

              /*
                      This section is to ensure we don't miss any jsSIP event
                      The array consists of the found session events in the jsSIP RTCSession code.
                      We gather these events, and log that they have occurred for debugging purposes
                       This is needed as the #catchJssipDebugLogs method cant catch errors sent on
                      jsSIP
                  */
              var unhandledEvents = ['getusermediafailed', 'peerconnection:setremotedescriptionfailed', 'newDTMF', 'newInfo', 'peerconnection', 'peerconnection:createofferfailed', 'peerconnection:createanswerfailed', 'peerconnection:setlocaldescriptionfailed', 'update', 'refer', 'replaces', 'sending', 'connecting', '_failed'];
              unhandledEvents.forEach(function (event) {
                session.on(event, function (args) {
                  var jsonArgs;

                  // Try to avoid "TypeError: Converting circular structure to JSON"
                  try {
                    jsonArgs = args && JSON.stringify(args);
                  } catch (_e) {
                    jsonArgs = undefined;
                  }
                  var unhandledMessage = "[jsSIP UNHANDLED EVENT] The following event occurred: ".concat(event);
                  unhandledMessage = jsonArgs ? unhandledMessage.concat("\nArguments:\n".concat(jsonArgs)) : unhandledMessage;
                  addPhoneLogEntry(unhandledMessage);
                });
              });
            });
            userAgent.on('connected', function () {
              nextAttempt = 1;
              addPhoneLogEntry('userAgent connected -> setting phone connected to true');
              addSipConnectionEstablishedDiv();
              dispatch(setPhoneConnected(true));
              addPhoneLogEntry('Sending SIP OPTIONS every 10000ms');
              sendEmptySipOptions(userAgent, getState());
            });
            userAgent.on('disconnected', /*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data) {
                var code, reason, host;
                return _regeneratorRuntime.wrap(function (_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      code = data && data.code || 'No code';
                      reason = data && data.reason || 'No reason';
                      host = data && data.socket && data.socket.url || 'No host url';
                      addPhoneLogEntry("userAgent disconnected from '".concat(host, "' with message '").concat(code, ": ").concat(reason, "'"));
                      if (!isStarted) {
                        _context4.next = 2;
                        break;
                      }
                      _context4.next = 1;
                      return updateSipProxiesThrottled();
                    case 1:
                      if (data && data.error && shouldReconnectSocket(userAgent)) {
                        addPhoneLogEntry('Our proxy is no longer in the list of SIP-proxies. Reconnecting socket.');
                        dispatch(restartUserAgent(userAgent, nextAttempt));
                      }
                    case 2:
                      clearInterval(sipOptionsIntervalId);
                      addPhoneLogEntry('Stopping to send SIP OPTIONS');
                      dispatch(setPhoneConnected(false));
                    case 3:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));
              return function (_x7) {
                return _ref7.apply(this, arguments);
              };
            }());
            userAgent.on('registered', function () {
              nextAttempt = 1;
              addPhoneLogEntry('userAgent registered -> setting phone registered to true');
              dispatch(setPhoneRegistered(true));
            });
            userAgent.on('unregistered', function (data) {
              var cause = data && data.cause || 'No cause';
              addPhoneLogEntry("Event 'unregistered'. Cause: '".concat(cause, "'"));
              dispatch(setPhoneRegistered(false));
            });
            userAgent.on('registrationExpiring', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
              var hasSessions;
              return _regeneratorRuntime.wrap(function (_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    addPhoneLogEntry("Event 'registrationExpiring'");
                    if (!selectGeoLocationIsReported(getState())) {
                      _context5.next = 2;
                      break;
                    }
                    _context5.next = 1;
                    return dispatch(resolveGeoLocationForSoftphone(GEO_FIX_WAIT_MS));
                  case 1:
                    setGeoLocationRegisterHeader(userAgent, getState());
                  case 2:
                    hasSessions = getNumLocalCalls(getState()) > 0; // Don't stop the UA if the user is in a call!
                    if (hasSessions) {
                      _context5.next = 4;
                      break;
                    }
                    addPhoneLogEntry('User not in call. Refetching SIP-proxies.');
                    _context5.next = 3;
                    return updateSipProxies();
                  case 3:
                    if (shouldReconnectSocket(userAgent)) {
                      addPhoneLogEntry('Our proxy is no longer in the list of SIP-proxies. Reconnecting socket.');
                      dispatch(restartUserAgent(userAgent));
                    } else {
                      addPhoneLogEntry('Sending SIP re-registration. Reusing same SIP-proxy.');
                      userAgent.register();
                    }
                    _context5.next = 5;
                    break;
                  case 4:
                    addPhoneLogEntry('User in call. Sending SIP re-registration. Reusing same SIP-proxy.');
                    userAgent.register();
                  case 5:
                  case "end":
                    return _context5.stop();
                }
              }, _callee5);
            })));
            userAgent.on('registrationFailed', function (data) {
              var response = data && data.response || 'No response';
              var cause = data && data.cause || 'No cause';
              addPhoneLogEntry("Event 'registrationFailed'. Response: '".concat(response, "', cause: '").concat(cause, "'"));
              dispatch(setPhoneRegistered(false));
              var hasSessions = getNumLocalCalls(getState()) > 0;
              if (hasSessions) {
                registerUserAgentOnCallEnded = true;
              } else {
                dispatch(restartUserAgent(userAgent, nextAttempt));
              }
            });
            userAgent.start();
            isStarted = true;
            dispatch({
              type: Actions.PHONE_NEW_UA,
              userAgent: userAgent
            });
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x5, _x6) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var shouldReconnectSocket = function shouldReconnectSocket(userAgent) {
  var currentProxy = userAgent.transport.socket.url;
  var proxyList = SIP_PROXIES.map(function (e) {
    return e.socketUrl;
  });
  return !proxyList.includes(currentProxy);
};
var sendEmptySipOptions = function sendEmptySipOptions(userAgent, state) {
  if (!userAgent) return;
  var sipInfo = getOwnSipUserInfo(state);
  var username = decryptSipInfo(sipInfo === null || sipInfo === void 0 ? void 0 : sipInfo.get('username'));
  var server = sipInfo === null || sipInfo === void 0 ? void 0 : sipInfo.get('server');
  if (!username || !server) return;
  var target = "sip:".concat(username, "@").concat(server);
  var eventHandlers = {
    failed: function failed() {
      return addPhoneLogEntry('Error sending SIP OPTIONS');
    }
  };
  var options = {
    eventHandlers: eventHandlers
  };
  sipOptionsIntervalId = setInterval(function () {
    var _userAgent$sendOption;
    (_userAgent$sendOption = userAgent.sendOptions) === null || _userAgent$sendOption === void 0 || _userAgent$sendOption.call(userAgent, target, null, options);
  }, 10000);
};
var restartUserAgent = function restartUserAgent(userAgent) {
  var nextAttempt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return function (dispatch) {
    // Stopping the UA disconnects all sockets
    addPhoneLogEntry('Stopping UserAgent');
    isStarted = false;
    userAgent.stop();
    // It takes at most 2 seconds for the UserAgent to be stopped.
    // Add this to the backoff to make sure we don't try to connect at the same time.
    var backoffTime = 2000 + calculateBackoffTime(nextAttempt - 1);
    addPhoneLogEntry("Making reconnection attempt #".concat(nextAttempt, " in ").concat(backoffTime, " ms"));
    var timeoutId = setTimeout(function () {
      dispatch(createUserAgent(nextAttempt));
    }, backoffTime);
    dispatch(setSipConnectionRetryTimeoutId(timeoutId));
  };
};
var setSipConnectionRetryTimeoutId = function setSipConnectionRetryTimeoutId(timeoutId) {
  return {
    type: Actions.SIP_RETRY_TIMEOUT_ID,
    timeoutId: timeoutId
  };
};
var setPhoneRegistered = function setPhoneRegistered(phoneRegistered) {
  return function (dispatch) {
    dispatch({
      type: Actions.PHONE_REGISTERED,
      registered: phoneRegistered
    });
  };
};
var setPhoneConnected = function setPhoneConnected(phoneConnected) {
  return function (dispatch) {
    dispatch({
      type: Actions.PHONE_CONNECTED,
      connected: phoneConnected
    });
  };
};
export var setPhoneEnabled = function setPhoneEnabled(phoneEnabled) {
  return function (dispatch) {
    dispatch({
      type: Actions.PHONE_ENABLED,
      enabled: phoneEnabled
    });
  };
};
export var call = function call(number, callMethod, extraCallOptions) {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch, getState) {
      var _getState2, phone, phoneEnabled, newCallBlockReason, sessions, holdSuccess, autoAnswerWithIpPhone, strippedNumber, designated, _t;
      return _regeneratorRuntime.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _getState2 = getState(), phone = _getState2.phone;
            phoneEnabled = phone.get('enabled');
            newCallBlockReason = hasActiveCallsBlockingNewCall(getState(), 'outgoing', 2);
            addPhoneLogEntry("About to perform call to number ".concat(number, " with call method ").concat(callMethod));
            if (!(newCallBlockReason !== NewCallBlockReason.NONE)) {
              _context7.next = 1;
              break;
            }
            addUserPhoneLogEntry("NOT performing new call, blocked by: ".concat(newCallBlockReason));
            return _context7.abrupt("return");
          case 1:
            sessions = getLocalCallSessions(getState());
            _context7.next = 2;
            return holdAllSessions(sessions);
          case 2:
            holdSuccess = _context7.sent;
            if (!holdSuccess) {
              addUserPhoneLogEntry('Failed to start outgoing call, could not hold current sessions');
            }

            // Re installed due to WEB-1556 so that customers with e.g. cisco terminals will be able to use
            // the web app as an redirect platform.
            autoAnswerWithIpPhone = getAutoAnswerWithIpPhone(getState());
            strippedNumber = removeExtraCharacters(number);
            addUserPhoneLogEntry("Formatted number ".concat(number, " to ").concat(strippedNumber, " prior to performing call"));

            // Model A: in companion mode this surface owns no media, so it must never dial locally -
            // ask the companion to dial from its own SIP UA instead, and the call lands on the machine
            // the user is actually at. This deliberately sits *above* the phoneEnabled check: that flag
            // means "softphone capability is available on this client" (see isPhoneEnabled in
            // app-actions), not "registered", so it is true for a normal Chrome CTI and would otherwise
            // send us straight to the local-dial switch below.
            //
            // Gated on the *surface*, not just the feature switch: the switch is per user, so it is also
            // true in that user's ordinary web app, which owns its own softphone and must keep dialling
            // locally. The surface check also carries the user's "Use Companion for calls" choice, so
            // turning that off drops straight through to the local paths below.
            //
            // Unlike mute and DTMF this cannot use shouldRelayToCompanion: at dial time there is no
            // session yet, so there is nothing to check for locally-owned media.
            //
            // canRelayCallToCompanion rather than the surface check alone, because falling through is a
            // working call and relaying blindly is a lost one: with no designated device, or one nobody
            // has opened in a fortnight, the push goes nowhere and nothing tells the user. The paths
            // below still ring something.
            if (!canRelayCallToCompanion(getState())) {
              _context7.next = 3;
              break;
            }
            designated = selectDesignatedCompanionDevice(getState());
            addUserPhoneLogEntry("Call -> companion mode is on, delegating call to the companion ".concat(designated.get('deviceId')));
            callOnCompanion(strippedNumber);
            return _context7.abrupt("return");
          case 3:
            if (isCompanionSignallingSurface(getState())) {
              addUserPhoneLogEntry('Call -> companion mode is on but no companion is reachable, falling back to this client');
            }
            if (phoneEnabled) {
              _context7.next = 4;
              break;
            }
            addUserPhoneLogEntry("Call -> softphone not available, defaulting to starting call through Home. AutoAnswer: ".concat(autoAnswerWithIpPhone));
            dispatch(startSipCallThroughHome(strippedNumber, autoAnswerWithIpPhone));
            return _context7.abrupt("return");
          case 4:
            _t = callMethod;
            _context7.next = _t === CallMethodType.LOCAL ? 5 : _t === CallMethodType.IP_PHONE ? 6 : _t === CallMethodType.MOBILE ? 7 : 8;
            break;
          case 5:
            dispatch(startLocalCall(strippedNumber, extraCallOptions));
            return _context7.abrupt("continue", 9);
          case 6:
            dispatch(startSipCallThroughHome(strippedNumber, autoAnswerWithIpPhone));
            return _context7.abrupt("continue", 9);
          case 7:
            dispatch(startMobileCallThroughHome(strippedNumber));
            return _context7.abrupt("continue", 9);
          case 8:
            console.warn('Unrecognized call method');
          case 9:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x8, _x9) {
      return _ref9.apply(this, arguments);
    };
  }();
};
export var holdCall = function holdCall(session) {
  return function (_dispatch, getState) {
    if (!session) {
      session = getFocusedSession(getState());
    }
    if (!session) {
      addPhoneLogEntry('Cannot hold call, no session found');
      return;
    }
    addPhoneLogEntry('Client using HOLD to park the current call session.');
    session.hold();
  };
};
export var unholdCall = function unholdCall(session) {
  return function (_dispatch, getState) {
    if (!session) {
      session = getFocusedSession(getState());
    }
    if (!session) {
      addPhoneLogEntry('Cannot unhold call, no session found');
      return;
    }
    addPhoneLogEntry('Client unparks the current call session via UNHOLD.');
    session.unhold();
  };
};
export var startLocalCall = function startLocalCall(number) {
  var extraCallOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(dispatch, getState) {
      var microphoneAllowed;
      return _regeneratorRuntime.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            if (!selectGeoLocationIsReported(getState())) {
              _context8.next = 1;
              break;
            }
            _context8.next = 1;
            return dispatch(ensureFreshGeoLocation());
          case 1:
            if (!selectPositionIsUnavailable(getState())) {
              _context8.next = 2;
              break;
            }
            addPhoneLogEntry('NOTE: Location sharing is off -- not going through with making the call');
            dispatch(setSnackbar({
              i18nextMessage: 'permission.location.not_granted',
              hasCloseButton: true
            }));
            return _context8.abrupt("return");
          case 2:
            _context8.next = 3;
            return permissionToMicrophoneIsGranted();
          case 3:
            microphoneAllowed = _context8.sent;
            if (microphoneAllowed) {
              dispatch(logAudioDeviceDataIfAppropriate());
              dispatch(setCallOptionsAndPerformCall(number, extraCallOptions));
            } else {
              addPhoneLogEntry('NOTE: Mic permission was not granted -- not going through with making the call');
              dispatch(setMicPermission(false));
            }
          case 4:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function (_x0, _x1) {
      return _ref0.apply(this, arguments);
    };
  }();
};
var setCallOptionsAndPerformCall = function setCallOptionsAndPerformCall(number) {
  var extraCallOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch, getState) {
    var _getState3 = getState(),
      phone = _getState3.phone;
    var mediaConstraints = getMediaConstraints(getState(), true);
    var OPTIONS = Object.assign({}, extraCallOptions, {
      mediaConstraints: mediaConstraints
    });
    var geoCoordinates = selectGeoLocationIsReported(getState()) ? selectGeoLocationCoordinates(getState()) : null;
    if (geoCoordinates) {
      OPTIONS.extraHeaders = [].concat(_toConsumableArray(extraCallOptions.extraHeaders || []), [geoLocationExtraHeader(geoCoordinates)]);
    }

    // Check userAgent
    var userAgent = phone.get('userAgent');
    if (!userAgent) {
      addPhoneLogEntry('ERROR: No phone user agent, CAN NOT perform new call');
      return;
    }
    var sipInfo = getOwnSipUserInfo(getState());
    var sipCluster = (sipInfo === null || sipInfo === void 0 ? void 0 : sipInfo.get('server')) || SIP_CLUSTER;
    var target = "sip:".concat(number, "@").concat(sipCluster);
    var session = userAgent && userAgent.call(target, OPTIONS);
    var peerConnection = session && session.connection;
    session.data.rtpPollingIntervalForDeterminingProgressTones = setInterval(function () {
      peerConnection.getStats().then(function (stats) {
        stats.forEach(function (stat) {
          if ((stat.kind === 'audio' || stat.mediaType === 'audio') && stat.type === 'inbound-rtp' && stat.packetsReceived) {
            stopTones('inbound audio rtp received');
            session.data['inboundAudioRtpReceived'] = true;
            clearInterval(session.data.rtpPollingIntervalForDeterminingProgressTones);
          }
        });
      })["catch"](function (error) {
        var _getFaro;
        if (errorMessageIsRTCPeerConnectionGone(error)) {
          stopTones('inbound audio rtp received');
          session.data['inboundAudioRtpReceived'] = true;
          clearInterval(session.data.rtpPollingIntervalForDeterminingProgressTones);
        }
        (_getFaro = getFaro()) === null || _getFaro === void 0 || _getFaro.api.pushError(error);
        addGeneralLogEntry("Error reported: ".concat(error));
      });
    }, 200);
    addConnectionEventListeners(session, dispatch);
  };
};
var startSipCallThroughHome = function startSipCallThroughHome(number) {
  var autoAnswer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch) {
    dispatch(startCallThroughHome(number, 'SIP', autoAnswer));
  };
};
var startMobileCallThroughHome = function startMobileCallThroughHome(number) {
  return function (dispatch) {
    dispatch(startCallThroughHome(number, 'MEX'));
  };
};
var startCallThroughHome = function startCallThroughHome(number, callType) {
  var autoAnswer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var activeCallDTO = {
    type: callType,
    number: number
  };
  return function (_dispatch, getState) {
    var extensionKey = getOwnExtensionKey(getState());
    ExtensionResource.createActiveCall({
      onResult: function onResult() {
        console.info('Call successfully started');
      }
    }, extensionKey, autoAnswer, activeCallDTO);
  };
};
export var answerOrHangupCall = function answerOrHangupCall(dispatch, getState) {
  var state = getState();
  var session = getFocusedSession(state);
  if (session) {
    if (session.direction === 'incoming' && !session.isEstablished()) {
      /**
       * Incoming call, not yet answered
       */
      dispatch(_answerCall(session));
    } else if (session.isEstablished()) {
      /**
       * Ongoing call
       */
      dispatch(hangupSession(session));
    }
  } else {
    addPhoneLogEntry('Cannot answer or hang up call, no session to answer or hangup found');
  }
};
var holdAllSessions = function holdAllSessions(sessions) {
  var exception = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var holdSuccess = sessions.every(function (iteratedSession) {
    if (exception && iteratedSession === exception) {
      return true;
    }
    if (iteratedSession.isOnHold().local) {
      return true;
    }
    if (!iteratedSession.isEstablished()) {
      return false;
    }
    return iteratedSession.hold();
  });
  return Promise.resolve(holdSuccess);
};
export var unholdAllSessions = function unholdAllSessions(sessions) {
  var exception = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var unholdSuccess = sessions.every(function (iteratedSession) {
    if (exception && iteratedSession === exception) {
      return true;
    }
    if (!iteratedSession.isOnHold().local) {
      return true;
    }
    if (!iteratedSession.isEstablished()) {
      return false;
    }
    return iteratedSession.unhold();
  });
  return Promise.resolve(unholdSuccess);
};
var _answerCall = function answerCall(session) {
  var throughHeadset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var answerHere = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return /*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(dispatch, getState) {
      var state, callId, sessions, holdSuccess, mediaConstraints, OPTIONS, coordinates, ticketData, ticketId, deepLinkId, _session$data2, micPermissionState, _t2, _t3;
      return _regeneratorRuntime.wrap(function (_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            state = getState();
            if (!session) {
              session = getFocusedSession(state);
            }
            if (session) {
              _context9.next = 1;
              break;
            }
            addPhoneLogEntry('Cannot answer call, no session found');
            return _context9.abrupt("return");
          case 1:
            if (!(!answerHere && selectCompanionAnswersCalls(state) && isRingingIncomingCall(session))) {
              _context9.next = 2;
              break;
            }
            callId = session.data['callId'];
            addUserPhoneLogEntry("Answer -> handing call ".concat(callId, " to the desktop app"));
            answerCompanionCall(callId);
            setTimeout(function () {
              if (isRingingIncomingCall(session)) {
                addUserPhoneLogEntry("Answer -> the desktop app did not take call ".concat(callId, ", answering here"));
                dispatch(_answerCall(session, throughHeadset, true));
              }
            }, COMPANION_ANSWER_FALLBACK_MS);
            return _context9.abrupt("return");
          case 2:
            dispatch(putMeetingOnHold(true));
            sessions = getLocalCallSessions(state);
            if (!(getCallWaitingEnabled(state) && sessions.size > 1)) {
              _context9.next = 5;
              break;
            }
            _context9.next = 3;
            return holdAllSessions(sessions, session);
          case 3:
            holdSuccess = _context9.sent;
            if (!holdSuccess) {
              _context9.next = 4;
              break;
            }
            addUserPhoneLogEntry('Put other calls on hold when answering call with callId: ', session.data['callId']);
            _context9.next = 5;
            break;
          case 4:
            addUserPhoneLogEntry('Could not answer call with callId: ', session.data['callId'], ' because other calls could not be put on hold');
            return _context9.abrupt("return");
          case 5:
            mediaConstraints = getMediaConstraints(getState(), true);
            OPTIONS = Object.assign({}, {
              mediaConstraints: mediaConstraints
            });
            if (!selectGeoLocationIsReported(getState())) {
              _context9.next = 7;
              break;
            }
            _context9.next = 6;
            return dispatch(ensureFreshGeoLocation());
          case 6:
            coordinates = selectGeoLocationCoordinates(getState());
            if (coordinates) {
              OPTIONS.extraHeaders = [geoLocationExtraHeader(coordinates)];
            }
          case 7:
            if (rtcSessionRepresentsTicketNonVoice(session)) {
              ticketData = getTicketDataFromRtcSessionRequest(session);
              ticketId = ticketData['ticketId'];
              if (ticketId) {
                addTicketLogEntry("SIP session answered. Routing user to ticket ".concat(ticketId));
                history.push(generatePath(routes['tickets.ticketKey'], {
                  ticketKey: "ticket-".concat(ticketId)
                }));
              } else {
                addTicketLogEntry('ticketId missing when answering SIP session');
              }
            }
            if (rtcSessionRepresentsCentionErrand(session)) {
              //An email or some other means of communication that is not a phone call
              deepLinkId = getCentionDataFromRtcSession(session, OMNICHANNEL_PROPERTIES.DEEP_LINK.value);
              if (deepLinkId) {
                dispatch(routeUserToOmnichannelErrand(deepLinkId, 'answerCall'));
              } else {
                //There should never be a case where this happens
                addOmniChannelLogEntry('deepLinkId missing when answering omnichannel errand session');
              }
            }

            /**
             * AC-811: Guard against double-dispatch of answerCall.
             * When a headset is connected, answering via the UI green button can cause
             * the headset SDK to also fire onAcceptCall, resulting in a second answerCall
             * dispatch. JsSIP's session.answer() only succeeds in STATUS_WAITING_FOR_ANSWER (4);
             * a second call after the status has moved to STATUS_ANSWERED (5) throws
             * INVALID_STATE_ERROR and skips addConnectionEventListeners, breaking audio.
             */
            if (!(!session.isInProgress() || session.isEstablished())) {
              _context9.next = 8;
              break;
            }
            addPhoneLogEntry("Skipping answer for call ".concat((_session$data2 = session.data) === null || _session$data2 === void 0 ? void 0 : _session$data2.callId, " \u2014 session already answered or not in progress (status: ").concat(session.status, ")"));
            return _context9.abrupt("return");
          case 8:
            _context9.prev = 8;
            _context9.next = 9;
            return getMicrophonePermissionState();
          case 9:
            micPermissionState = _context9.sent;
            if (!(micPermissionState === permissionTypes.DENIED)) {
              _context9.next = 10;
              break;
            }
            addPhoneLogEntry('NOTE: Mic permission denied -- not going through with answering the call');
            dispatch(setMicPermission(false));
            return _context9.abrupt("return");
          case 10:
            if (micPermissionState === permissionTypes.GRANTED) {
              dispatch(setMicPermission(true));
            }
            _context9.next = 12;
            break;
          case 11:
            _context9.prev = 11;
            _t2 = _context9["catch"](8);
            addPhoneLogEntry("NOTE: Could not check mic permission state, proceeding with answer: ".concat(_t2));
          case 12:
            _context9.prev = 12;
            dispatch(logAudioDeviceDataIfAppropriate());
            session.answer(OPTIONS);
            _context9.next = 14;
            break;
          case 13:
            _context9.prev = 13;
            _t3 = _context9["catch"](12);
            // This is a safeguard for not crashing the app in electron when answer is triggered multiple times
            // We know this happens when headset controls are active and we answer the call by clicking the green answer button in the
            // call canvas. We get an onAcceptCall which triggers an answerCall dispatch after having already dispatched answerCall.
            // TODO: WEB-14414- Fix this properly by not calling answerCall twice
            /*
             * AC-811: The isInProgress/isEstablished guard above now prevents the known
             * double-dispatch scenario from reaching this point. This catch block remains
             * as a last-resort safety net for any other unexpected JsSIP errors (e.g.
             * WebRTC failures, opaqueTransport errors) that could surface during
             * session.answer(). If you see this log line in production, investigate the
             * error — it likely indicates a new failure mode, not the old double-answer bug.
             */
            addPhoneLogEntry("Failed to answer call: ".concat(_t3));
            return _context9.abrupt("return");
          case 14:
            session.data.answeredThroughHeadset = throughHeadset;
            addConnectionEventListeners(session, dispatch);
          case 15:
          case "end":
            return _context9.stop();
        }
      }, _callee9, null, [[8, 11], [12, 13]]);
    }));
    return function (_x10, _x11) {
      return _ref1.apply(this, arguments);
    };
  }();
};
export { _answerCall as answerCall };
var handleReceiveStream = function handleReceiveStream(stream, session) {
  return function (dispatch, getState) {
    var _getState4 = getState(),
      phone = _getState4.phone,
      headsets = _getState4.headsets;
    var audioReference = phone.get('audioReference');
    audioReference.srcObject = stream;
    var mediaDevices = headsets.get('connectedMediaDevices');
    var preferredAudioOutputId = headsets.get('preferredAudioOutputId');
    var preferredAudioOutput = getConnectedMediaDeviceOfKindWithId(mediaDevices, 'audiooutput', preferredAudioOutputId);
    var preferredAudioOuputLabel = preferredAudioOutput ? preferredAudioOutput.label : '';
    addDeviceLogEntry('Media has preferred output device id: ' + preferredAudioOutputId + ' found: ' + !!preferredAudioOutput + ' name: ' + preferredAudioOuputLabel);
    if (preferredAudioOutput) {
      setOutputDeviceWithIdToElement(preferredAudioOutput.deviceId, audioReference);
    }
    dispatch(enableDtmf(stream, session));
  };
};
var enableDtmf = function enableDtmf(stream, session) {
  return function (dispatch) {
    var peerConnection = session && session.connection;
    if (peerConnection) {
      var dtmfSender = createDtmfSender(peerConnection, stream);
      dispatch(registerDtmfSender(dtmfSender));
      session.data['DTMFSender'] = dtmfSender;
    }
  };
};
var createDtmfSender = function createDtmfSender(peerConnection, stream) {
  if (peerConnection.getSenders) {
    return peerConnection.getSenders()[0].dtmf;
  } else {
    // If the browser does not support .getSenders()
    // we fall back to use the deprecated .createDTMFSender().
    var audioTracks = stream.getAudioTracks();
    return peerConnection.createDTMFSender(audioTracks[0]);
  }
};

/** How long this surface shows its own intent before falling back to what the call says. */
var PENDING_MUTE_TIMEOUT_MS = 5000;

/**
 * Identifies one press, so that only that press's own timeout can retire it.
 *
 * The user may well mute and unmute in quick succession on purpose, and each press arms its own
 * timeout. Without a tag an earlier press's timeout clears a later press's intent, and the button
 * falls back to the call - which still carries the older state until the companion reports - so it
 * flips back under the user's finger.
 */
var pendingMuteToken = 0;
export var mutePhone = function mutePhone() {
  var mute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return function (dispatch, getState) {
    var state = getState();

    // No media here, so the companion does the muting and reports back through TOP.
    if (shouldRelayToCompanion(state)) {
      var focusedActiveCall = getFocusedActiveCall(state);
      var focusedCallId = focusedActiveCall ? focusedActiveCall.get('callId') : null;
      muteCompanion(mute);
      dispatch({
        type: Actions.PHONE_MUTED,
        muted: mute,
        callId: focusedCallId
      });
      // Until the companion's report arrives the call still carries the old state, so
      // show the intent instead. Cleared by an agreeing report, or by the timeout.
      pendingMuteToken += 1;
      var token = pendingMuteToken;
      dispatch({
        type: Actions.PHONE_MUTE_PENDING,
        muted: mute,
        token: token,
        // The call the intent is about. Reports arrive for every call this client can see,
        // including other extensions', and only one for this call can settle it.
        callKey: focusedActiveCall ? focusedActiveCall.get('key') : null
      });
      setTimeout(function () {
        dispatch({
          type: Actions.PHONE_MUTE_PENDING_CLEARED,
          token: token
        });
      }, PENDING_MUTE_TIMEOUT_MS);
      return;
    }
    var sessions = getLocalCallSessions(state);
    sessions.forEach(function (session) {
      // Only what actually took effect is reported: other surfaces treat it as the
      // companion's real state, so a request that muted nothing must not travel as fact.
      // Still every request rather than every change - asking for a mute the endpoint is
      // already in applies cleanly and fires no session event, and a surface showing the
      // opposite would have nothing to correct it. Per session, so each names its channel.
      if (dispatch(muteCall(mute, session))) {
        dispatch(publishCompanionMuteState(mute, session));
      }
    });
  };
};
export var muteCall = function muteCall() {
  var mute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var session = arguments.length > 1 ? arguments[1] : undefined;
  return function (dispatch) {
    dispatch({
      type: Actions.PHONE_MUTED,
      muted: mute,
      callId: session.data.callId
    });
    // Attempting to mute a session without track puts it in a bad state
    if (!sessionHasAudioTracks(session)) {
      console.warn("Attempted to ".concat(mute ? 'mute' : 'unmute', " a session without audio tracks"));
      return false;
    }
    try {
      if (mute) {
        session.mute();
      } else {
        session.unmute();
      }
    } catch (error) {
      /**
       * When this occurrs, it's typically because the user has pressed
       * mute button on her headset while there's no call to mute.
       */
      var muteString = mute ? 'mute' : 'unmute';
      var infoMessage = "Attempted to ".concat(muteString, " but failed.");
      var phoneLogEntry = "".concat(infoMessage, " Error: ").concat(error);
      addPhoneLogEntry(phoneLogEntry);
      return false;
    }
    return true;
  };
};
export var hangupSession = function hangupSession(session) {
  var throughHeadset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch, getState) {
    if (!session) {
      session = getFocusedSession(getState());
    }
    dispatch(putMeetingOnHold(false));
    if (!session || session.isEnded()) {
      return;
    }
    addPhoneLogEntry('Hangup -> Attempting to stop locally generated tones');
    stopTones();
    session.data.hungupThroughHeadset = throughHeadset;
    if (session.direction === 'incoming' && session.isInProgress()) {
      if (selectCompanionAnswersCalls(getState()) && isRingingIncomingCall(session)) {
        addUserPhoneLogEntry("Decline -> declining call ".concat(session.data['callId'], " on the desktop app too"));
        declineCompanionCall(session.data['callId']);
      }
      if (getLocalCallIds(getState()).length > 1) {
        dispatch(segmentTrack(EVENT_STRINGS.USER_DECLINED_SECOND_CALL, {
          callId: session.data['callId']
        }));
      }
      session.terminate(BUSY_TERMINATE_OPTIONS);
    } else {
      session.terminate();
    }
  };
};
export var setSoftphoneShouldBeRegistered = function setSoftphoneShouldBeRegistered(shouldBeRegistered) {
  return function (dispatch) {
    saveSoftphoneShouldBeRegistered(shouldBeRegistered);
    if (shouldBeRegistered) {
      dispatch(registerUserAgent());
    } else {
      dispatch(unregisterUserAgent());
    }
  };
};
export var setPlayRingtoneSetting = function setPlayRingtoneSetting(playRingtoneSetting) {
  return function (dispatch) {
    savePlayRingtoneSetting(playRingtoneSetting);
    dispatch(receivePlayRingtoneSetting(playRingtoneSetting));
  };
};
export var loadPlayRingtoneSetting = function loadPlayRingtoneSetting() {
  return function (dispatch) {
    var playRingtoneSetting = getPlayRingtoneSetting();
    dispatch(receivePlayRingtoneSetting(playRingtoneSetting));
  };
};
export var receivePlayRingtoneSetting = function receivePlayRingtoneSetting(playRingtoneSetting) {
  return {
    type: Actions.PHONE_PLAY_RINGTONE_SETTING,
    playRingtoneSetting: playRingtoneSetting.key
  };
};
var registerUserAgent = function registerUserAgent() {
  return function (_dispatch, getState) {
    var state = getState();
    var phone = state.phone;
    if (phone.get('isRegistered')) {
      return;
    }
    if (selectPositionIsUnavailable(state) || selectCallingNeedsCompanion(state)) {
      addPhoneLogEntry('Not registering the softphone: calling is blocked in this region');
      return;
    }
    var userAgent = phone.get('userAgent');
    if (userAgent) {
      userAgent.register();
    }
  };
};
var unregisterUserAgent = function unregisterUserAgent() {
  return function (_dispatch, getState) {
    var _getState5 = getState(),
      phone = _getState5.phone;
    var userAgent = phone.get('userAgent');
    if (userAgent) {
      userAgent.unregister();
    }
  };
};

// Sends a SIP un-REGISTER and resolves once the registrar acknowledges it (the
// UA's 'unregistered' event), or immediately when there is no UserAgent. Used by
// the Electron main process on quit: it holds the quit until this resolves so
// the registration is removed while the renderer is still alive, instead of
// being left as a ghost (the renderer's own beforeunload can't reliably flush
// the un-REGISTER during teardown). The main process owns the single safety
// timeout that lets the app quit if the registrar never responds, so there is
// deliberately no timeout here.
export var unregisterUserAgentBeforeQuit = function unregisterUserAgentBeforeQuit() {
  return function (_dispatch, getState) {
    var userAgent = getState().phone.get('userAgent');
    if (!userAgent) {
      return Promise.resolve();
    }
    return new Promise(function (resolve) {
      userAgent.once('unregistered', function () {
        return resolve();
      });
      userAgent.unregister();
    });
  };
};
var registerDtmfSender = function registerDtmfSender(dtmfSender) {
  return {
    type: Actions.PHONE_NEW_DTMF_SENDER,
    dtmf: dtmfSender
  };
};
var setPaiHeader = function setPaiHeader(pai) {
  return {
    type: Actions.SET_PAI_HEADER,
    pai: pai
  };
};
var removePaiHeader = function removePaiHeader() {
  return {
    type: Actions.REMOVE_PAI_HEADER
  };
};
export var registerPhoneAudioReference = function registerPhoneAudioReference(reference) {
  return function (dispatch) {
    dispatch({
      type: Actions.PHONE_AUDIO_REFERENCE,
      reference: reference
    });
  };
};
export var transferCall = function transferCall(activeCallDTO) {
  return function (dispatch, getState) {
    var myExtensionKey = getOwnExtensionKey(getState());
    var activeCallKey = activeCallDTO.key;
    return new Promise(function (resolve, reject) {
      ExtensionResource.updateActiveCall({
        onResult: function onResult(/*json*/
        ) {
          // Do nothing. We get back the same activeCallDTO as we sent.
          resolve();
        },
        onError: function onError() {
          networkErrorDispatcher(dispatch);
          reject();
        },
        onClientError: function onClientError() {
          reject();
        }
      }, myExtensionKey, activeCallKey, activeCallDTO);
    });
  };
};
export var registerTransferPending = function registerTransferPending(callKey, extensionKey, number, contact) {
  return function (dispatch, getState) {
    var session = getFocusedSession(getState());
    session === null || session === void 0 || session.unhold();
    dispatch({
      type: Actions.EXTENSION_ATTENDED_TRANSFER_PENDING,
      callKey: callKey,
      extensionKey: extensionKey,
      number: number,
      contact: contact
    });
  };
};
export var resolveTransferPending = function resolveTransferPending(uniqueId, reason) {
  return function (dispatch, getState) {
    // Since we can get 'AttendedTransferCancelled' events via top for any monitored extension,
    // we need to verify that it is for the current users transfer. This is done by comparing
    // the UniqueId in the cancel event to the key used to start the transfer. Since channels
    // can be renamed during a transfer, we compare against the "base" unique id.
    if (uniqueId) {
      var currentTransferCallKey = getPendingTransferCallKey(getState());
      if (!currentTransferCallKey) {
        return;
      }
      // e.g currentTransferCallKey = 'activecall-12345.1.2' => currentTransferBaseUniqueId = '12345'
      var currentTransferBaseUniqueId = /activecall-(\d+).*/.exec(currentTransferCallKey)[1];
      // e.g uniqueId = '12345.1.2.3' => baseUniqueId = '12345
      var baseUniqueId = /(\d+).*/.exec(uniqueId)[1];
      if (currentTransferBaseUniqueId !== baseUniqueId) {
        return;
      }
    }
    var extensionKey = getOwnExtensionKey(getState());
    addUserPhoneLogEntry("Attended transfer completed or cancelled, reason: ".concat(reason));
    dispatch({
      type: Actions.EXTENSION_ATTENDED_TRANSFER_RESOLVED,
      extensionKey: extensionKey
    });
  };
};
export var playRingTone = function playRingTone() {
  return function (_dispatch, getState) {
    var _getState6 = getState(),
      phone = _getState6.phone,
      ringtones = _getState6.ringtones;
    var ringtoneEntityKey = ringtones.getIn(['settings', 'key']);
    var playRingtoneSetting = PlayRingtoneSetting.get(phone.get('playRingtoneSetting'));
    if (playRingtoneSetting === PlayRingtoneSetting.SILENT) {
      addPhoneLogEntry('Not playing Flow ringtone due to silent mode being set');
      return;
    }
    if (selectCompanionAnswersCalls(getState())) {
      addPhoneLogEntry('Not playing Flow ringtone, the desktop app rings for this call');
      return;
    }

    // Catch error since we don't want the page to break if the browser is lacking support.
    try {
      addPhoneLogEntry("Playing Flow ringtone with key ".concat(ringtoneEntityKey));
      RingTonePlayer.play();
    } catch (error) {
      addPhoneLogEntry("Failed playing Flow ringtone with key ".concat(ringtoneEntityKey, " due to error: ").concat(error));
      console.error(error);
    }
  };
};
export var playRingbackTone = function playRingbackTone() {
  return function (_dispatch, getState) {
    var _getState7 = getState(),
      app = _getState7.app,
      customer = _getState7.customer;
    var contact = app.getIn(['extension', 'contact']);
    var extensionKey = getOwnExtensionKey(getState());
    var loggedinCustomer = customer.get(extensionKey);
    var countryCode = getCountryCode(contact, loggedinCustomer);

    // Catch error since we don't want the page to break if the browser is lacking support.
    try {
      addPhoneLogEntry("Playing progress tone for country code: ".concat(countryCode));
      ToneGenerator.playRingbackTone(countryCode);
    } catch (error) {
      addPhoneLogEntry("Failed playing progress tone due to error: ".concat(error));
      console.error(error);
    }
  };
};
var playBusyTone = function playBusyTone() {
  try {
    addPhoneLogEntry('Playing locally generated busy tone');
    // It needs to be delayed to busy tone-not-playing-every-second-time.
    setTimeout(function () {
      ToneGenerator.playBusyTone();
    }, 0);
  } catch (error) {
    addPhoneLogEntry("Failed playing busy tone due to error: ".concat(error));
    console.error("Failed to play busy tone ".concat(error));
  }
};
var playDisconnectTone = function playDisconnectTone() {
  try {
    addPhoneLogEntry('Playing locally disconnect tone');
    // It needs to be delayed to play the tone after the call has ended.
    setTimeout(function () {
      ToneGenerator.playDisconnectTone();
    }, 0);
  } catch (error) {
    addPhoneLogEntry("Failed playing locally generated disconnect tone due to error: ".concat(error));
    console.error("Failed to play locally generated disconnect tone ".concat(error));
  }
};
var stopTones = function stopTones(reasonString) {
  // Catch error since we don't want the page to break if the browser is lacking support.
  try {
    var stoppingString = 'Stopping locally generated tones';
    var logString = reasonString ? "".concat(stoppingString, " because ").concat(reasonString) : stoppingString;
    addPhoneLogEntry(logString);
    ToneGenerator.stopRunningTone();
    RingTonePlayer.stop();
  } catch (error) {
    addPhoneLogEntry("Failed stopping locally generated tones due to error: ".concat(error));
    console.error(error);
  }
};

/**
 * @param {string} number the destination
 * @param {string} [triggeredFrom] where the transfer was started, for the log
 * @param {string} [targetCallId] transfer this call rather than the focused one. See sendDTMF for
 *   why the companion has to name it: focus here is not evidence of which call the user meant.
 */
export var transferBlindCall = function transferBlindCall(number) {
  var triggeredFrom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unknown';
  var targetCallId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return function (dispatch, getState) {
    var state = getState();
    var targetActiveCall = targetCallId ? getOwnActiveCallByCallId(state, targetCallId) : getFocusedActiveCall(state);
    var activeCallKey = targetActiveCall ? targetActiveCall.get('key') : 'activecall-unknown';
    var isReturnBlindTransferActive = !!getBlindTransferSetting(BLIND_TRANSFER_SETTINGS.ACTIVE);
    var returnDestination = isReturnBlindTransferActive ? getBlindTransferSetting(BLIND_TRANSFER_SETTINGS.RETURN_DESTINATION) : null;
    var returnDelay = isReturnBlindTransferActive && returnDestination ? getBlindTransferSetting(BLIND_TRANSFER_SETTINGS.RETURN_DELAY) || 15 : null;
    var activeCallDTO = {
      key: activeCallKey,
      callTransfer: _objectSpread(_objectSpread({
        destination: number,
        transferType: CallTransferType.blind.key
      }, returnDestination && {
        returnDestination: returnDestination
      }), returnDelay && {
        returnDelay: returnDelay
      })
    };
    addUserPhoneLogEntry("Activated blind transfer from location: ".concat(triggeredFrom, "\nBlind transfer settings:\n"), activeCallDTO);
    dispatch(transferCall(activeCallDTO));
  };
};
export var transferAttendedCall = function transferAttendedCall(number) {
  var transferContact = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unknown';
  var triggeredFrom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'unknown';
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee0(dispatch, getState) {
      var focusedActiveCall, activeCallKey, ownExtensionKey, activeCallDTO, _t4;
      return _regeneratorRuntime.wrap(function (_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            if (!getPendingTransferCallKey(getState())) {
              _context0.next = 1;
              break;
            }
            addUserPhoneLogEntry("Ignored attended transfer from ".concat(triggeredFrom, " to ").concat(number, ": a transfer is already pending"));
            dispatch(setSnackbar({
              i18nextMessage: 'callcontrol.transfer_already_pending'
            }));
            return _context0.abrupt("return");
          case 1:
            focusedActiveCall = getFocusedActiveCall(getState());
            activeCallKey = focusedActiveCall ? focusedActiveCall.get('key') : '';
            ownExtensionKey = getOwnExtensionKey(getState());
            activeCallDTO = {
              key: activeCallKey,
              callTransfer: {
                destination: number,
                transferType: CallTransferType.attended.key,
                attendedTransferState: AttendedTransferState.pending.key
              }
            };
            addUserPhoneLogEntry("Activated attended transfer from location: ".concat(triggeredFrom, "\nAttended transfer to: ").concat(number));
            dispatch(registerTransferPending(activeCallKey, ownExtensionKey, number, transferContact));
            _context0.prev = 2;
            _context0.next = 3;
            return dispatch(transferCall(activeCallDTO));
          case 3:
            _context0.next = 5;
            break;
          case 4:
            _context0.prev = 4;
            _t4 = _context0["catch"](2);
            dispatch(resolveTransferPending(undefined, 'start transfer failed'));
          case 5:
          case "end":
            return _context0.stop();
        }
      }, _callee0, null, [[2, 4]]);
    }));
    return function (_x12, _x13) {
      return _ref10.apply(this, arguments);
    };
  }();
};
export var completeAttendedTransfer = function completeAttendedTransfer() {
  return /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee1(dispatch, getState) {
      var state, activeCallDTO, _t5;
      return _regeneratorRuntime.wrap(function (_context1) {
        while (1) switch (_context1.prev = _context1.next) {
          case 0:
            state = getState();
            activeCallDTO = {
              key: getPendingTransferCallKey(state),
              callTransfer: {
                destination: getPendingTransferNumber(state),
                transferType: CallTransferType.attended.key,
                attendedTransferState: AttendedTransferState.complete.key
              }
            };
            _context1.prev = 1;
            _context1.next = 2;
            return dispatch(transferCall(activeCallDTO));
          case 2:
            _context1.next = 4;
            break;
          case 3:
            _context1.prev = 3;
            _t5 = _context1["catch"](1);
            addUserPhoneLogEntry('Error when user tried to complete the attended transfer');
            return _context1.abrupt("return");
          case 4:
            dispatch(resolveTransferPending(undefined, 'transfer complete by user interaction'));
          case 5:
          case "end":
            return _context1.stop();
        }
      }, _callee1, null, [[1, 3]]);
    }));
    return function (_x14, _x15) {
      return _ref11.apply(this, arguments);
    };
  }();
};
export var cancelAttendedTransfer = function cancelAttendedTransfer() {
  return /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(dispatch, getState) {
      var state, activeCallDTO, _t6;
      return _regeneratorRuntime.wrap(function (_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            state = getState();
            activeCallDTO = {
              key: getPendingTransferCallKey(state),
              callTransfer: {
                destination: getPendingTransferNumber(state),
                transferType: CallTransferType.attended.key,
                attendedTransferState: AttendedTransferState.cancel.key
              }
            };
            _context10.prev = 1;
            _context10.next = 2;
            return dispatch(transferCall(activeCallDTO));
          case 2:
            _context10.next = 4;
            break;
          case 3:
            _context10.prev = 3;
            _t6 = _context10["catch"](1);
            addUserPhoneLogEntry('Error when user tried to cancel the attended transfer');
            return _context10.abrupt("return");
          case 4:
            dispatch(resolveTransferPending(undefined, 'transfer cancelled by user interaction'));
          case 5:
          case "end":
            return _context10.stop();
        }
      }, _callee10, null, [[1, 3]]);
    }));
    return function (_x16, _x17) {
      return _ref12.apply(this, arguments);
    };
  }();
};
export var toggleCallWaiting = function toggleCallWaiting(callWaitingDTO) {
  return function (dispatch, getState) {
    var myExtensionKey = getOwnExtensionKey(getState());
    var callWaiting = callWaitingDTO.get('callWaiting');
    dispatch({
      type: Actions.SET_CALL_WAITING,
      callWaiting: callWaitingDTO
    });
    dispatch(segmentTrack(EVENT_STRINGS.USER_TOGGLED_CALL_WAITING, {
      isEnabled: callWaiting
    }));
    ExtensionResource.setCallWaiting({
      onResult: function onResult() {},
      onError: networkErrorDispatcher(dispatch)
    }, myExtensionKey, callWaitingDTO.toJS());
    addUserPhoneLogEntry('Call waiting toggled ' + callWaiting ? 'on' : 'off');
  };
};
export var swapCall = function swapCall(callId) {
  return function (dispatch, getState) {
    var state = getState();
    dispatch(segmentTrack(EVENT_STRINGS.USER_SWAPPED_CALLS, {
      callId: callId
    }));
    var sessions = getLocalCallSessions(state);
    if (selectMeetingIsActive(state)) {
      if (selectMeetingIsInFocus(state)) {
        dispatch(putMeetingOnHold(true));
      } else {
        dispatch(putMeetingOnHold(false));
      }
    }
    sessions.forEach(function (session) {
      if (session.data['callId'] === callId) {
        session.unhold();
      } else {
        session.hold();
      }
    });
  };
};

/**
 * Batch DTMF for the companion. Every keypress is its own action, so relaying each one separately
 * meant an HTTP round-trip and a TOP push per digit, with no ordering guarantee between them -
 * typing a nine-digit IVR selection sent nine commands. Digits are buffered here and flushed as one
 * command once the user stops pressing.
 *
 * The local tone is still played per keypress by the caller, so the keypad stays responsive; only
 * the network command is delayed. The companion hands the whole string to RTCDTMFSender, which
 * applies its own inter-tone gap.
 */
var COMPANION_DTMF_FLUSH_MS = 400;
// Bound the buffer so a stuck key cannot grow it without limit before the idle flush fires.
var COMPANION_DTMF_MAX_DIGITS = 32;
var companionDtmfDigits = '';
var companionDtmfCallId = null;
var companionDtmfTimer = null;
var flushCompanionDtmf = function flushCompanionDtmf() {
  if (companionDtmfTimer) {
    clearTimeout(companionDtmfTimer);
    companionDtmfTimer = null;
  }
  if (!companionDtmfDigits || !companionDtmfCallId) {
    return;
  }
  var digits = companionDtmfDigits;
  var callId = companionDtmfCallId;
  companionDtmfDigits = '';
  companionDtmfCallId = null;
  sendCompanionDtmf(digits, callId);
};
var bufferCompanionDtmf = function bufferCompanionDtmf(symbol, callId) {
  // Switching call mid-burst must not merge digits across calls.
  if (companionDtmfCallId && companionDtmfCallId !== callId) {
    flushCompanionDtmf();
  }
  companionDtmfCallId = callId;
  companionDtmfDigits += symbol;
  if (companionDtmfDigits.length >= COMPANION_DTMF_MAX_DIGITS) {
    flushCompanionDtmf();
    return;
  }
  if (companionDtmfTimer) {
    clearTimeout(companionDtmfTimer);
  }
  companionDtmfTimer = setTimeout(flushCompanionDtmf, COMPANION_DTMF_FLUSH_MS);
};

/**
 * @param {string|number} symbol the digit(s) to send
 * @param {string} [targetCallId] send on this call rather than the focused one. The companion
 *   passes it because the call a relayed command names is not necessarily the one in focus here -
 *   the user is pressing keys on another machine, so this client's focus says nothing about which
 *   call they meant, and with two calls up the tones would otherwise land in the wrong one.
 */
export var sendDTMF = function sendDTMF(symbol) {
  var targetCallId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var playLocalTone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (_dispatch, getState) {
    var state = getState();

    // Model A: the tone has to be injected into the RTP stream, which lives on the companion.
    // Play it locally too so the keypad still feels responsive to the user pressing it.
    if (shouldRelayToCompanion(state)) {
      var focusedActiveCall = getFocusedActiveCall(state);
      var remoteCallId = focusedActiveCall ? focusedActiveCall.get('callId') : null;
      if (!remoteCallId) {
        addUserPhoneLogEntry('DTMF in companion mode with no focused call, ignoring');
        return;
      }
      if (typeof symbol == 'number' || symbol.length === 1) {
        ToneGenerator.playDigit(symbol);
      }
      bufferCompanionDtmf(String(symbol), remoteCallId);
      return;
    }
    var localCallId = targetCallId || getFocusedLocalCallId(state);
    var targetSession = getLocalSessionFromCallId(state, localCallId);
    var dtmfSender = targetSession && targetSession.data['DTMFSender'];
    if (senderSupportsDtmf(dtmfSender)) {
      // Suppressed when the keypress happened somewhere else. The companion runs in the
      // background and the user is pressing keys on another surface, which plays its own
      // feedback tone - and with the CTI and the companion on one machine, playing it here
      // too means the user hears every digit twice. The tone that matters is the one
      // insertDTMF puts in the RTP stream; this one is only UI feedback.
      if (playLocalTone && (typeof symbol == 'number' || symbol.length === 1)) {
        ToneGenerator.playDigit(symbol);
      }
      dtmfSender.insertDTMF(symbol);
    }
  };
};
export var toggleFocusedCall = function toggleFocusedCall(dispatch, getState) {
  var state = getState();
  var focusedActiveCall = getFocusedActiveCall(state);
  if (focusedActiveCall) {
    dispatch(toggleCall(focusedActiveCall.get('key')));
  }
};
export var getPinCode = function getPinCode(callKey, meetingCode) {
  return /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(dispatch, getState) {
      var result, fetchUrl, res, pin, extensionKey, _t7;
      return _regeneratorRuntime.wrap(function (_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            if (!meetingCode) {
              _context11.next = 3;
              break;
            }
            fetchUrl = homeActionUrlPath("/api/external/conference/".concat(meetingCode, "/pin"));
            _context11.next = 1;
            return fetch(fetchUrl, {
              method: 'post'
            });
          case 1:
            res = _context11.sent;
            _context11.next = 2;
            return res.json();
          case 2:
            result = _context11.sent;
          case 3:
            _context11.next = 5;
            break;
          case 4:
            _context11.prev = 4;
            _t7 = _context11["catch"](0);
            addUserPhoneLogEntry("Error fetching call key for meetingcode ".concat(meetingCode, ":"), _t7);
          case 5:
            if (!result) {
              _context11.next = 6;
              break;
            }
            pin = result.pin;
            extensionKey = getOwnExtensionKey(getState());
            _context11.next = 6;
            return dispatch(setPinCode(extensionKey, callKey, pin));
          case 6:
            return _context11.abrupt("return", result);
          case 7:
          case "end":
            return _context11.stop();
        }
      }, _callee11, null, [[0, 4]]);
    }));
    return function (_x18, _x19) {
      return _ref13.apply(this, arguments);
    };
  }();
};